
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Typography, Box } from '@mui/material';
import React from 'react';
import ReleaseNotesSection from './ReleaseNotesSection'


export default function ReleaseNotes(props) {
    const { changelog, latest } = props
    let defaultExpanded = false
    if (latest == true){
        defaultExpanded = true
    }



    return(
        <Accordion defaultExpanded={defaultExpanded}>
            <AccordionSummary 
                expandIcon={<ArrowDropDownIcon />}
            >
                {changelog['version']}
                &nbsp;&nbsp;&nbsp;
                <em>{changelog['date']}</em>
                &nbsp;&nbsp;&nbsp;
                <b>{changelog['main_title']}</b>

            </AccordionSummary>
            <Box sx={{marginLeft: '20px'}}>

            <Typography>{changelog['description']}</Typography>
            <br/><br/>
            {
                changelog['new_features'] 
                ?
                <ReleaseNotesSection name="Features" data={changelog['new_features']}></ReleaseNotesSection>
                :
                <></>
            }     
            {
                changelog['fixes'] 
                ?
                <ReleaseNotesSection name="Fixes" data={changelog['fixes']}></ReleaseNotesSection>
                :
                <></>
            }   
            {
                changelog['improvements'] 
                ?
                <ReleaseNotesSection name="Improvements" data={changelog['improvements']}></ReleaseNotesSection>
                :
                <></>
            }    
                  
            
            </Box>

            </Accordion>     
    )


}